import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppDataService } from '../app-data.service';
import { Partner } from '../data/model';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  setParams(params: any): any {
    const paramsToSend: any = {};
    paramsToSend.params = params;
    return paramsToSend;
  }

  constructor(private http: HttpClient, private globalData: AppDataService) { }

  getAllPartners(params: any): any {
    return this.http.get(this.globalData.baseUrl + 'organizations/partners', this.setParams(params));
  }

  getPartner(id: number): any {
    return this.http.get(this.globalData.baseUrl + 'organizations/partners/' + id);
  }

  createOrUpdatePartner(id: number, data: Partner): any {
    if (id) {
      return this.http.put(this.globalData.baseUrl + 'organizations/partners/' + id, data);
    }
    return this.http.post(this.globalData.baseUrl + 'organizations/partners/', data);
  }
}
